import { matchType } from "../../../../../../application/domain/base/base-type";
import {
  DangerSecondaryButton,
  InformationBanner,
  SecondaryButton,
  SecondaryStatusTag,
  WarningBanner,
} from "@graffer-inc/console-design-kit";
import { Link } from "react-router-dom";
import { SmartApplyR } from "../../../route";
import {
  cantIssueDescription,
  showDetailDescription,
  showDetailTitle,
} from "../../../../../../application/domain/qualified-invoice/issue-request";
import { QualifiedInvoiceIssueRequest } from "@graffer-inc/smart-apply";

type Props = {
  isLoading: boolean;
  issueUIState:
    | "DISABLE_BUTTON"
    | "CAN_ISSUE"
    | "SHOW_DETAIL"
    | "WITHDRAWN"
    | "REVOKED";
  issueControlStatus: {
    isIssuableProcedure: boolean;
    hasTaxablePayment: boolean;
    isPaymentCompleted: boolean;
    isIssuableApplicationStatus: boolean;
  };
  applicationId: string;
  availableIssuedQualifiedInvoice: QualifiedInvoiceIssueRequest["availableIssuedQualifiedInvoice"];
  handleOnSetRedirectToIssueForm: () => void;
  handleOnWithdraw: () => void;
  handleOnRevoke: () => void;
};

export const QualifiedInvoiceIssueRequestRequested: React.FC<Props> = ({
  isLoading,
  issueUIState,
  issueControlStatus: {
    isIssuableProcedure,
    hasTaxablePayment,
    isPaymentCompleted,
    isIssuableApplicationStatus,
  },
  applicationId,
  availableIssuedQualifiedInvoice,
  handleOnSetRedirectToIssueForm,
  handleOnWithdraw,
  handleOnRevoke,
}) => {
  return (
    <>
      {matchType(issueUIState, {
        CAN_ISSUE: <></>,
        DISABLE_BUTTON: (
          <div className="mb-4">
            <InformationBanner
              message={
                "下記の理由により、支払い明細書を交付することができません。"
              }
              description={cantIssueDescription({
                isIssuableProcedure,
                hasTaxablePayment,
                isPaymentCompleted,
                isIssuableApplicationStatus,
              })}
            />
          </div>
        ),
        SHOW_DETAIL: (!hasTaxablePayment || !isPaymentCompleted) && (
          <div className="mb-4">
            <WarningBanner
              message={showDetailTitle({
                hasTaxablePayment,
                isPaymentCompleted,
              })}
              description={showDetailDescription({
                hasTaxablePayment,
                isPaymentCompleted,
              })}
            />
          </div>
        ),
        WITHDRAWN: <></>,
        REVOKED: (!isIssuableProcedure ||
          !hasTaxablePayment ||
          !isPaymentCompleted ||
          !isIssuableApplicationStatus) && (
          <div className="mb-4">
            <InformationBanner
              message={
                "下記の理由により、支払い明細書を再交付することができません。"
              }
              description={cantIssueDescription({
                isIssuableProcedure,
                hasTaxablePayment,
                isPaymentCompleted,
                isIssuableApplicationStatus,
              })}
            />
          </div>
        ),
      })}
      <div className="box">
        <nav className="level">
          <div className="level-left">
            <div className="level-item has-text-left">
              <h3 className="title is-size-6 mr-2">対応状況</h3>
              <nav className="level">
                {matchType(issueUIState, {
                  CAN_ISSUE: (
                    <SecondaryStatusTag type="PRIMARY">
                      未交付
                    </SecondaryStatusTag>
                  ),
                  DISABLE_BUTTON: (
                    <SecondaryStatusTag type="PRIMARY">
                      未交付
                    </SecondaryStatusTag>
                  ),
                  SHOW_DETAIL: (
                    <>
                      <div className="level-item has-text-left">
                        <SecondaryStatusTag type="SUCCESS">
                          交付済み
                        </SecondaryStatusTag>
                      </div>
                      {!!availableIssuedQualifiedInvoice && (
                        <p className="level-item has-text-centered">
                          <Link
                            to={SmartApplyR.ApplicationQualifiedInvoiceShow.link(
                              {
                                id: applicationId,
                                qualifiedInvoiceId:
                                  availableIssuedQualifiedInvoice.id,
                              },
                            )}
                          >
                            詳細
                          </Link>
                        </p>
                      )}
                    </>
                  ),
                  WITHDRAWN: (
                    <SecondaryStatusTag type="LIGHT">
                      取り下げ済み
                    </SecondaryStatusTag>
                  ),
                  REVOKED: (
                    <SecondaryStatusTag type="PRIMARY">
                      未交付
                    </SecondaryStatusTag>
                  ),
                })}
              </nav>
            </div>
          </div>
          <div className="level-right">
            {matchType(issueUIState, {
              CAN_ISSUE: (
                <>
                  <div className="level-item has-text-centered">
                    <SecondaryButton
                      text="交付する"
                      onClick={handleOnSetRedirectToIssueForm}
                    />
                  </div>
                  <div className="level-item has-text-centered">
                    <DangerSecondaryButton
                      text="依頼を取り下げる"
                      disabled={isLoading}
                      onClick={handleOnWithdraw}
                    />
                  </div>
                </>
              ),
              DISABLE_BUTTON: (
                <div className="level-item has-text-centered">
                  <DangerSecondaryButton
                    text="依頼を取り下げる"
                    disabled={isLoading}
                    onClick={handleOnWithdraw}
                  />
                </div>
              ),
              SHOW_DETAIL: (
                <div className="level-item has-text-centered">
                  <DangerSecondaryButton
                    text="交付を取り消す"
                    disabled={isLoading}
                    onClick={handleOnRevoke}
                  />
                </div>
              ),
              WITHDRAWN: <></>,
              REVOKED: (
                <>
                  {isIssuableProcedure &&
                    hasTaxablePayment &&
                    isPaymentCompleted &&
                    isIssuableApplicationStatus && (
                      <div className="level-item has-text-centered">
                        <SecondaryButton
                          text="再交付する"
                          onClick={handleOnSetRedirectToIssueForm}
                        />
                      </div>
                    )}
                  <div className="level-item has-text-centered">
                    <DangerSecondaryButton
                      text="依頼を取り下げる"
                      disabled={isLoading}
                      onClick={handleOnWithdraw}
                    />
                  </div>
                </>
              ),
            })}
          </div>
        </nav>
      </div>
    </>
  );
};
